var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticStyle: { "min-height": "450px" } }, [
    !_vm.hasScale
      ? _c("input", {
          staticClass: "form-control",
          attrs: { type: "number" },
          domProps: { value: _vm.value },
          on: {
            input: function ($event) {
              _vm.updateValue(parseFloat($event.target.value))
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.hasScale
      ? _c(
          "div",
          { staticClass: "list-group" },
          _vm._l(_vm.scaleLevels, function (sl) {
            return _c(
              "a",
              {
                staticClass:
                  "list-group-item list-group-item-action text-center",
                class: {
                  "bg-success": _vm.value === sl.Value,
                  "bg-white": _vm.value !== sl.Value,
                },
                on: {
                  click: function ($event) {
                    return _vm.updateValue(sl.Value)
                  },
                },
              },
              [
                _c("strong", [
                  _vm._v(_vm._s(sl.Value) + " - " + _vm._s(sl.Name)),
                ]),
                _vm._v(" "),
                sl.Definition
                  ? _c("p", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(sl.Definition)),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.value != null
      ? _c("div", { staticClass: "text-center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-link mt1",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.updateValue(null)
                },
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-times",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" Clear answer\n        "),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", { staticStyle: { "margin-top": "15px" } }, [
      _c("textarea", {
        staticClass: "form-control",
        attrs: { rows: "5", placeholder: "Comment..." },
        domProps: { value: _vm.comment },
        on: {
          input: function ($event) {
            return _vm.updateComment($event.target.value)
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }